import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BreadcrumbItems, SliderFooterInfo, SliderMenuItem } from '../typing';
@Component({
  selector: 'bcsc-digi-app',
  templateUrl: './slider-menu.component.html',
  styleUrls: ['./slider-menu.component.scss'],
})
export class SliderMenuComponent implements OnChanges, OnDestroy, AfterViewInit {

  isCollapsed = false;

  @Input() sliderMenuItems: SliderMenuItem[] = [];
  @Input() footerMenuItems: SliderMenuItem[] = [];
  @Input() footerInfo: SliderFooterInfo = {};
  @Input() avater = '';
  @Input() title = '';
  @Input() sliderMenuWidth = '264px';
  @Output() toggleCollapsed = new EventEmitter();

  menuHeight = 48;
  bodyMenuHeight = '100%';
  selectItem = '';
  breadcrumbItems: BreadcrumbItems[] = [];
  observer: MutationObserver | undefined;

  constructor(
    private router: Router,
    ) {
      this.listemRouter();
  }

  listemRouter() {
    this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd) {
        this.selectedMenuByUrl();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    // 计算主题菜单的高度， 当显示不下时候可以滚动
    const footerMenuItems = changes['footerMenuItems'];
    if (footerMenuItems && footerMenuItems.currentValue) {
      let totalItem = 0;
      footerMenuItems.currentValue.forEach((item: SliderMenuItem) => { 
        if (item?.items) {
          totalItem += item.items.length;
        }
      });
      totalItem += footerMenuItems.currentValue.length;
      this.bodyMenuHeight = `calc(100% - ${totalItem + 156}px)`;
    }

    const sliderMenuItems = changes['sliderMenuItems'];
    if (sliderMenuItems && sliderMenuItems.currentValue) {
      this.selectedMenuByUrl();
    }
  }

  selectedMenuByUrl() {
    const menu = this.sliderMenuItems.find((menu: SliderMenuItem) => menu.url && location.pathname.indexOf(menu.url) !== -1);
    if (menu) {
      if (menu.items) {
        const subMenu = menu.items.find((item: SliderMenuItem) => item.url && location.pathname.indexOf(item.url) !== -1);
        if (subMenu) {
          this.selectItem = subMenu.title
          this.breadcrumbItems = [{ url: menu.url, label: menu.title }, { label: subMenu.title }];
        }
      } else {
        this.selectItem = menu.title;
        this.breadcrumbItems = [{ label: menu.title }];
      }
    } else if (this.sliderMenuItems.length) {
      const first = this.sliderMenuItems[0];
      if (first?.items && first.items.length) {
        this.selectItem = first.items[0].title;
        this.breadcrumbItems = [{ url: first.url, label: first.title }, { label: first.items[0].title }];
      } else {
        this.selectItem = first.title;
        this.breadcrumbItems = [{ label: first.title }];
      }
    }
  }

  ngAfterViewInit(): void {
      this.observerDom();
  }

  ngOnDestroy(): void {
      this.selectItem = '';
      if (this.observer) {
        this.observer.disconnect();
      }
  }

  onToggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
    this.toggleCollapsed.emit({ isCollapsed: this.isCollapsed });
  }

  onMenuClick({ target, parent }: any) {
    if (parent) {
      this.breadcrumbItems = [{ url: parent.url, label: parent.title }, { label: target.title }];
    } else {
      this.breadcrumbItems = [{ label: target.title }];
    }
    this.selectItem = target.title;
    if (target?.url) {
      this.router.navigateByUrl(target.url)
    }
    if (target?.cb) {
      target.cb(target);
    }
  }

  observerDom() {
    const container = document.querySelector('#digi-slider-menu');
    if (container) {
      this.observer = new MutationObserver(() => {
        const menu = this.sliderMenuItems.find((menu: SliderMenuItem) => menu.url && location.pathname.indexOf(menu.url) !== -1);
      if (menu) {
        if (menu.items) {
          const subMenu = menu.items.find((item: SliderMenuItem) => item.url && location.pathname.indexOf(item.url) !== -1);
          if (subMenu) {
            this.selectItem = subMenu.title
          }
        } else {
          this.selectItem = menu.title;
        }
      }
      });
      this.observer.observe(container, { attributes: true });
    }
  }
}
